import { cn } from "@/lib/utils";

const MessageTime = ({ timestamp, className }) => {
  if (!timestamp) return null;

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  return <div className={cn("text-xs text-gray-500 mt-1", className)}>{formatTime(timestamp)}</div>;
};

export default MessageTime;
